<ngb-datepicker [minDate]="minDate" [maxDate]="maxDate" [startDate]="startDate" firstDayOfWeek="7" [navigation]="navigation" #dp></ngb-datepicker>
<div class="button__container">
	<button (click)="onStartDateSelected()" class="btn">Hoy</button>
</div>